import Modal from "react-modal";
import { CalendarIcon, CrossIcon } from "../../assets";
import styles from "./styles.module.scss";
import { COLORS } from "../../constants";
import { Button, EditableMacroEquation, StatsBlock } from "../../components";
import { IUser } from "../../models";
import { formatNumberToLocaleString } from "../../utils/methods";
import {
  getUserCalorieGoal,
  overrideUserRecommendation,
} from "../../services/users.service";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";

const UpdateUserRecommendation = ({
  isOpen,
  setIsOpen,
  user,
  refetchUser,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  user: IUser;
  refetchUser: () => void;
}) => {
  const queryClient = useQueryClient();
  const { data } = useQuery({
    queryKey: ["user-calorie-goal", user?.id],
    queryFn: () => {
      return getUserCalorieGoal(user?.id);
    },
  });

  const { mutate: overrideUserRecommendationMutation, isPending } = useMutation(
    {
      mutationFn: (eat: string) => {
        return overrideUserRecommendation(user?.id, +eat);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["user-calorie-goal", user?.id],
        });
        toast.success("Override successful", {
          position: "top-right",

          style: {
            width: 250,
            textAlign: "left",
          },
        });
        refetchUser();

        setIsOpen(false);
      },
    }
  );

  const [eat, setEat] = useState(
    data?.recommendedDailyIntake?.toFixed(1) || ""
  );

  useEffect(() => {
    setEat(data?.recommendedDailyIntake?.toFixed(1) || "");
  }, [data?.recommendedDailyIntake]);

  const isDisabled = +eat === 0 || +eat > (data?.tdee || 0);

  return (
    <Modal
      isOpen={isOpen}
      shouldFocusAfterRender={false}
      onRequestClose={() => setIsOpen(false)}
      overlayClassName={styles.overlay}
      className={styles.modal}
      ariaHideApp={false}
    >
      <div className={styles.innerContainer}>
        <h5 className={styles.title}>Update User Recommendation</h5>
        <CrossIcon
          onClick={() => setIsOpen(false)}
          className={styles.closeBtn}
        />
        <StatsBlock
          title="Last logged weight"
          value={
            <>
              {formatNumberToLocaleString(user?.weight?.current || 0, 1)}{" "}
              <span>{user?.weight?.unit}</span>
            </>
          }
          width={180}
          icon={
            <CalendarIcon
              style={{ fill: COLORS.brown, width: "24px", height: "24px" }}
            />
          }
        />
        <EditableMacroEquation
          eat={eat}
          burn={data?.tdee || 0}
          onChangeEat={setEat}
        />
        <div className={styles.buttonsContainer}>
          <Button
            title="Save"
            size="small"
            styleType={isDisabled ? "disabled" : "filled"}
            disabled={isDisabled}
            loading={isPending}
            onClick={() => overrideUserRecommendationMutation(eat)}
          />
          <Button
            title="Cancel"
            onClick={() => setIsOpen(false)}
            size="small"
            styleType="disabled"
          />
        </div>
      </div>
    </Modal>
  );
};

export default UpdateUserRecommendation;
